import { render } from "./SearchButtons.vue?vue&type=template&id=5e350f53&scoped=true"
import script from "./SearchButtons.vue?vue&type=script&lang=js"
export * from "./SearchButtons.vue?vue&type=script&lang=js"

import "./SearchButtons.vue?vue&type=style&index=0&id=5e350f53&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e350f53"]])

export default __exports__